<template>
  <v-snackbar
    v-model="show"
    class="mt-4 alert-bar"
    :color="type"
    :timeout="timeout"
    fixed
    top
  >
    <div class="d-flex align-center">
      <v-icon left> {{ icons[type] }} </v-icon>

      <div class="d-flex">
        <div class="text-subtitle-2">{{ message }}</div>
      </div>

      <v-spacer />

      <v-btn v-if="timeout < 0" icon small @click="show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  name: "AlertBar",

  data() {
    return {
      show: false,
      icons: {
        success: "mdi-check-circle",
        error: "mdi-alert-octagon-outline",
        warning: "mdi-alert-outline",
        info: "mdi-alert-circle-outline",
      },
      message: "",
      type: "",
      timeout: 10000,
    };
  },

  methods: {
    handleAlert(data) {
      this.message = data.message;
      this.type = data.type;
      this.timeout = data.fixed ? -1 : data.timeout || 10000;
      this.show = true;
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
